(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benori-widerruf"] && !Shopify.designMode) return;
  try {
    
  /*
   * <benori-widerruf>: Knopf [data-widerruf-open] öffnet den Formularbereich [data-widerruf-panel],
   * setzt aria-expanded, legt den Fokus auf die Formularüberschrift und sagt das Öffnen über die
   * Live-Region [data-widerruf-live] an. Mit #widerruf-formular in der Adresse ist das Formular sofort offen.
   * Das App-iframe bekommt den Titel aus den Abschnitts-Einstellungen (die App setzt nur einen englischen).
   */
  (() => {
    if (customElements.get('benori-widerruf')) return;
    const OPEN_HASH = '#widerruf-formular';

    class BenoriWiderruf extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.querySelector('[data-widerruf-open]')?.addEventListener('click', () => this.open(true), { signal });
        window.addEventListener('hashchange', () => this.fromHash(), { signal });
        this.nameFrames();
        this.observer = new MutationObserver(() => this.nameFrames());
        this.observer.observe(this, { childList: true, subtree: true });
        this.fromHash();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }

      nameFrames() {
        const title = this.dataset.frameTitle;
        if (!title) return;
        for (const frame of this.querySelectorAll('[data-widerruf-panel] iframe')) {
          if (frame.title !== title) frame.title = title;
        }
      }

      fromHash() {
        if (window.location.hash === OPEN_HASH) this.open(false);
      }

      open(announce) {
        const panel = this.querySelector('[data-widerruf-panel]');
        if (!panel) return;
        const wasOpen = panel.dataset.state === 'open';
        panel.dataset.state = 'open';
        this.querySelector('[data-widerruf-open]')?.setAttribute('aria-expanded', 'true');

        const target = panel.querySelector('[data-widerruf-title]') || panel;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        requestAnimationFrame(() => {
          target.focus({ preventScroll: true });
          target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        });

        const live = this.querySelector('[data-widerruf-live]');
        const message = this.dataset.openMessage || '';
        if (announce && !wasOpen && live && message) {
          live.textContent = '';
          window.setTimeout(() => {
            live.textContent = message;
          }, 120);
        }
      }
    }

    customElements.define('benori-widerruf', BenoriWiderruf);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
